import styled from 'styled-components'

import { Select } from '../common/Select'
import { UserSelect } from '../input/UserSelect'
import { InternshipSelect } from '../input/InternshipSelect'
import { GridSelect } from '../input/GridSelect'

import { createField } from './createField'
import { MaxWidth } from './InputField'

const widthify = (component) => styled(component)`
${MaxWidth}
`
export const SelectField = createField({ Component: Select })
export const SelectFieldWidth = widthify(SelectField)

export const UserField = createField({ Component: UserSelect })
export const UserFieldWidth = widthify(UserField)

export const InternshipField = createField({ Component: InternshipSelect })
export const InternshipFieldWidth = widthify(InternshipField)

export const GridField = createField({ Component: GridSelect })
export const GridFieldWidth = widthify(GridField)
